/* import __COLOCATED_TEMPLATE__ from './environment-selector.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */

import templateOnly from '@ember/component/template-only';
import type Environment from 'embercom/models/standalone/environment';

interface Args {
  environmentOptions: Array<{ text: string; value: string }>;
  selectedEnvironment?: Environment;
  onSelectEnvironment: (environmentId: string) => void;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

const EnvironmentSelector = templateOnly<Signature>();
export default EnvironmentSelector;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InstallationNew::Web::InitialSetup::EnvironmentSelector': typeof EnvironmentSelector;
  }
}
